import { html, TemplateResult } from 'lit';
import { BookingRequest } from '../../types/booking-request';
import { showStepWhenCurrentIs, stepId, STEP_THANK_YOU } from '../../types/steps';
import { WPContent } from '../../types/wp-data';
import { stepIntro } from './partials/step-intro';

export function stepThankYou(
	state: BookingRequest,
	content: WPContent
): TemplateResult {
	if ( !( showStepWhenCurrentIs( STEP_THANK_YOU, state.currentStep ) ) ) {
		return html``;
	}

	return html`
		<div class="step" id="${stepId( STEP_THANK_YOU )}">
			<div class="section theme-grey-light">
				<div class="wrapper">
					<div class="double-columns">
						<div class="double-columns__column">
							${stepIntro( content.titleThankYouMessage, content.textThankYouMessage )}
						</div>
					</div>
				</div>
			</div>
		</div>
	`;
}
